import axios from 'axios';

const getApiKey = async () => {
  const apiKeyArray = [
    '7TFBPVAJZLDPUVPA',
    'X8MKGVI67K4GY95Y',
    'ZT4BU53UINSFIYWH',
  ];
  const randomIndex = Math.floor(Math.random() * apiKeyArray.length);
  return apiKeyArray[randomIndex];
};

const GetPriceHistory = async (ticker) => {
  const apiKey = await getApiKey();
  const data = axios
    .get(
      `https://www.alphavantage.co/query?function=TIME_SERIES_DAILY_ADJUSTED&symbol=${ticker}&outputsize=compact&apikey=${apiKey}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
  return data;
};

export default GetPriceHistory;
